export const terms = {
  title: 'EachTeach 이용약관',
  notice: '※본 문서는 일본어를 정문(정식이며 법적으로 우선되는 문서)으로 하며, 영어·한국어는 참고 번역입니다. 해석에 차이가 발생할 경우 일본어 버전이 우선합니다.',
  
  article1: {
    title: '제1조(정의)',
    intro: '본 약관에서 다음 용어는 다음과 같은 의미를 갖습니다.',
    operator: {
      term: '「운영」:',
      definition: 'EachTeach의 기획·관리·운영을 수행하는 자'
    },
    service: {
      term: '「본 서비스」:',
      definition: '운영이 제공하는 온라인 언어 교환·학습 지원 서비스'
    },
    user: {
      term: '「이용자」:',
      definition: '본 약관에 동의한 후 본 서비스를 이용하는 모든 자'
    },
    session: {
      term: '「세션」:',
      definition: '운영이 지정하는 방법으로 진행되는 언어 교환·학습 시간(원칙적으로 90분)'
    }
  },
  
  article2: {
    title: '제2조(서비스 내용)',
    point1: '본 서비스는 이용자의 언어 수준, 학습 목적 등을 기반으로 운영이 참가자를 매칭하고 온라인 세션을 제공하는 것입니다.',
    point2: '세션은 운영이 제공하거나 지정하는 워크시트 및 진행 규칙에 따라 실시됩니다.',
    point3: '성장형 단어장(Word Pool)을 제외하고, 본 서비스의 기능 및 세션은 유료입니다.'
  },
  
  article3: {
    title: '제3조(이용 자격)',
    point1: '※본 서비스는 교육·학습 지원을 목적으로 하며, 직업 알선, 자격 발급, 공식 시험 대비를 목적으로 하지 않습니다.',
    point2: '이용자는 안정적인 인터넷 환경 및 온라인 통화 수단을 스스로의 책임 하에 준비해야 합니다.',
    point3: '미성년자가 본 서비스를 이용하는 경우, 보호자의 사전 동의를 얻은 후 이용해야 하며, 운영으로부터 요청받을 경우 동의 여부를 확인할 수 있는 자료를 제출해야 합니다.'
  },
  
  article4: {
    title: '제4조(등록 정보 및 계정 관리)',
    point1: '이용자는 정확하고 최신의 정보를 등록해야 합니다.',
    point2: '이용자는 자신의 등록 정보 및 이용 환경에 대해 모든 책임을 집니다.',
    point3: '허위 정보 또는 부정 이용이 판명될 경우, 운영은 사전 통지 없이 이용 정지 또는 등록 말소를 할 수 있습니다.'
  },
  
  article5: {
    title: '제5조(요금·결제·취소)',
    point1: '본 서비스의 요금, 결제 방법, 제공 형태(단발·회수제·월액 등)는 운영이 별도로 정하는 안내에 따릅니다.',
    point2: {
      main: '각 세션의 예정일을 기준으로 3일 전보다 이전에 운영이 지정한 방법으로 취소 연락이 도달한 경우에 한해 취소를 접수합니다.',
      sub1: '「3일 전」이란 세션 예정일을 포함하지 않는 3일 전 날짜의 23:59까지(일본 시간·JST)를 의미합니다.',
      sub2: '(예: 10일 개최의 경우, 6일 23:59까지 유효, 7일 이후의 연락은 무효)'
    },
    point3: '회수권제의 경우, 각 세션에 대해 예정일 3일 전 0:00(JST)에 자동으로 1회분이 소비됩니다.',
    point4: '자동 소비 후에는 이용자 사정에 의한 결석, 중도 퇴장, 통신 환경 불비, 시차 인식 차이, 건강 불량 등의 이유를 포함하여 환불, 대체, 보상은 일체 하지 않습니다.',
    point5: '천재지변, 법령 개정, 외부 인프라 장애 등 운영의 합리적 통제를 초과하는 사유로 서비스 제공이 불가능하게 된 경우의 처리는 운영이 별도로 정하는 방법에 따릅니다.',
    point6: '월정액 플랜의 요금은 매월 25일에 익월분을 구매하는 형태로 청구됩니다(익월분 선불).',
    point7: '월정액 플랜의 해지를 원하시는 경우 당월 15일까지 소정의 해지 절차를 완료해 주세요. 15일까지 절차가 완료되면 익월분 이후의 청구가 중지됩니다. 16일 이후의 절차는 익익월분부터 중지됩니다.'
  },
  
  article6: {
    title: '제6조(금지 사항)',
    intro: '이용자는 다음 행위를 해서는 안 됩니다.',
    item1: '괴롭힘, 차별적 언동, 위압적 행위, 폭언',
    item2: '종교, 정치, 상업 기타 영리 목적의 권유 행위',
    item3: '교재, 워크시트, 콘텐츠의 무단 전재, 복제, 재배포',
    item4: '다른 이용자, 운영 또는 제3자의 권리·이익을 침해하는 행위',
    item5: '본 서비스의 운영을 방해하는 행위',
    item6: '법령 또는 공서양속에 반하는 행위'
  },
  
  article7: {
    title: '제7조(지적재산권)',
    content: '본 서비스와 관련하여 제공되는 교재, 문장, 디자인, 시스템 등의 지적재산권은 운영 또는 정당한 권리자에게 귀속됩니다.'
  },
  
  article8: {
    title: '제8조(녹화·AI·데이터 이용)',
    point1: '운영은 품질 관리, 문제 대응, 서비스 개선을 목적으로 필요 최소한의 범위에서 세션 내용을 녹화, 녹음 또는 텍스트화할 수 있습니다.',
    point2: '전항의 데이터는 개인을 직접 특정할 수 없는 형태로 통계 분석, 품질 평가, 향후 기능 개선에 이용될 수 있습니다.',
    point3: '해당 데이터는 법령에 근거한 경우를 제외하고 제3자에게 제공하거나 공개되지 않습니다.'
  },
  
  article9: {
    title: '제9조(면책 사항)',
    point1: '본 서비스는 언어 학습 및 교류의 기회를 제공하는 것이며, 특정 성과, 향상, 자격 취득 등을 보장하지 않습니다.',
    point2: '이용자 간 또는 제3자와의 사이에서 발생한 문제에 대해 운영은 합리적 범위를 초과하여 책임을 지지 않습니다.',
    point3: '통신 장애, 외부 서비스 중단, 시스템 오류 등으로 인해 발생한 손해에 대해 운영은 책임을 지지 않습니다.'
  },
  
  article10: {
    title: '제10조(서비스의 변경·중단·종료)',
    content: '운영은 필요하다고 판단한 경우 사전 통지 없이 본 서비스의 전부 또는 일부를 변경, 중단 또는 종료할 수 있습니다.'
  },
  
  article11: {
    title: '제11조(약관의 변경)',
    point1: '운영은 필요에 따라 본 약관을 개정할 수 있습니다.',
    point2: '개정 후 이용자가 본 서비스를 이용한 경우, 해당 개정에 동의한 것으로 간주합니다.'
  },
  
  article12: {
    title: '제12조(준거법·관할)',
    content: '본 약관은 일본법을 준거법으로 하며, 본 서비스와 관련하여 발생한 분쟁에 대해서는 운영 소재지를 관할하는 법원을 제1심의 전속적 합의 관할로 합니다.'
  }
};
